import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useBankCode, useIdType } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import React, { useEffect, useState } from 'react';
import { isLocaleEnglish } from 'utils/languageUtils';
import Visibility from 'assets/images/eye-open.svg';
import VisibilityOff from 'assets/images/eye-off.svg';
import {
  // formatCardNumber2,
  // formatCardNumber4,
  formatIdlast5,
} from 'utils/formate/cardNumber';

// import styled from 'styled-components';
export const PaymentConfrimCard = (props: { paymentMethodEn: string }) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const { token } = useKeycloakReady();
  const [idTypedefult, setidType] = useState('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const idTypeList: { label: string; value: string }[] = [];
  const isEnglish = isLocaleEnglish(i18n.language);
  const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');
  const { data: idType, shouldFetch: shouldFetchIdType } = useIdType(token || '');
  // const [showCardMask, setShowCardMask] = useState<boolean>(true);
  // const [showCardNoMask, setShowCardNoMask] = useState<boolean>(true);
  const [showIdCard, setShowIdCard] = useState<boolean>(true);

  useEffect(() => {
    shouldFetchIdType(true);
  }, [shouldFetchIdType]);
  useEffect(() => {
    shouldFetchBankList(true);
  }, [shouldFetchBankList]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const myBankList: { label: string; value: string }[] = [];
  bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
    myBankList.push({
      label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
      value: item.bankCode,
    });
  });
  const [bankdefult, setbankdefult] = useState('');
  idType?.map((item: { idTypeDesc: string; idTypeDescTc: string; idType: string }) => {
    idTypeList.push({
      label: isEnglish ? item.idTypeDesc : item.idTypeDescTc,
      value: item.idTypeDesc,
    });
  });
  useEffect(() => {
    const a = idTypeList?.find((item) => item.value === form.getFieldValue('IDtype'))?.label;
    if (a) {
      setidType(a);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [setidType, idTypeList, form]);
  useEffect(() => {
    const a = myBankList?.find((item) => item.value === form.getFieldValue('bankCode'))?.label;
    if (a) {
      setbankdefult(a);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [setidType, myBankList, form]);
  // const changeCardMask = () => {
  //   setShowCardMask(!showCardMask);
  // };
  // const changeCardNoMask = () => {
  //   setShowCardNoMask(!showCardNoMask);
  // };
  console.log('form', props.paymentMethodEn);
  return (
    <div>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        {form.getFieldValue('paymentMode') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.Paymentmode')}
                </span>
              }
              name="paymentMode"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {isEnglish ? props.paymentMethodEn : form.getFieldValue('paymentModeTc')}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('RenewalPaymentMethod') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.Renewal')}
                </span>
              }
              name="RenewalPaymentMethod"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  {isEnglish
                    ? form.getFieldValue('RenewalPaymentMethoden')
                    : form.getFieldValue('RenewalPaymentMethodtc')}
                </div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
      </Row>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        {form.getFieldValue('accountHolder') && !form.getFieldValue('branchNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.AccountHolder')}
                </span>
              }
              name="accountHolder"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {form.getFieldValue('accountHolder')}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('CreditCard') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.CreditCardNumber')}
                </span>
              }
              name="CreditCard"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {
                  // !showCardNoMask?
                  form.getFieldValue('CreditCard')
                  // : formatCardNumber4(form.getFieldValue('CreditCard'))
                }
                {/* {showCardNoMask ? (
                  <img src={Visibility} onClick={changeCardNoMask} />
                ) : (
                  <img src={VisibilityOff} onClick={changeCardNoMask} />
                )} */}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('expiryDate') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.CreditCardDate')}
                </span>
              }
              name="expiryDate"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {form.getFieldValue('expiryDate')}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
      </Row>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        {form.getFieldValue('bankCode') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.BankCode')}
                </span>
              }
              name="bankCode"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {bankdefult}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('branchNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.BranchNumber')}
                </span>
              }
              name="branchNumber"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div> {form.getFieldValue('branchNumber')}</div>
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('bankAccountNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.BankAccountNumber')}
                </span>
              }
              name="bankAccountNumber"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {
                  // !showCardMask?
                  form.getFieldValue('bankAccountNumber')
                  // : formatCardNumber2(form.getFieldValue('bankAccountNumber'))
                }
                {/* {showCardMask ? (
                  <img src={Visibility} onClick={changeCardMask} />
                ) : (
                  <img src={VisibilityOff} onClick={changeCardMask} />
                )} */}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('accountHolder') && form.getFieldValue('branchNumber') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.AccountHolderName')}
                </span>
              }
              name="accountHolder"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {form.getFieldValue('accountHolder')}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('IDtype') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.IDType')}
                </span>
              }
              name="IDtype"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {idTypedefult}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
        {form.getFieldValue('passport') && (
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.IDCard')}
                </span>
              }
              name="IDCard"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {!showIdCard ? form.getFieldValue('passport') : formatIdlast5(form.getFieldValue('passport'))}
                {showIdCard ? (
                  <img src={Visibility} onClick={() => setShowIdCard(!showIdCard)} />
                ) : (
                  <img src={VisibilityOff} onClick={() => setShowIdCard(!showIdCard)} />
                )}
              </div>
            </BoldLabelFormItem>
          </Col>
        )}
      </Row>
    </div>
  );
};
